/**
 * DUNAMIS WEAR — Quick Add
 */
(function () {
  'use strict';
  const theme = window.theme;

  document.addEventListener('click', function (e) {
    const quickAddBtn = e.target.closest('[data-quick-add]');
    if (!quickAddBtn) return;
    e.preventDefault();

    const card = quickAddBtn.closest('[data-product-card]');
    const productId = card.dataset.productId;
    const sizes = card.querySelector('[data-quick-add-sizes]');

    if (sizes) {
      sizes.hidden = !sizes.hidden;
      return;
    }

    const variantId = quickAddBtn.dataset.variantId;
    if (variantId && theme.addToCart) {
      theme.addToCart({ id: parseInt(variantId, 10), quantity: 1 });
    }
  });

  document.addEventListener('click', function (e) {
    const sizeBtn = e.target.closest('[data-quick-add-size]');
    if (!sizeBtn || sizeBtn.disabled) return;
    e.preventDefault();
    const variantId = sizeBtn.dataset.variantId;
    if (variantId && theme.addToCart) {
      theme.addToCart({ id: parseInt(variantId, 10), quantity: 1 });
      const sizes = sizeBtn.closest('[data-quick-add-sizes]');
      if (sizes) sizes.hidden = true;
    }
  });
})();
